import { matchPath } from 'react-router-dom'
import { RouteParams, routes } from '@sketch/modules-common'
import { ProjectFragment } from '@sketch/gql-types'

export const isViewingCurrentProject = (
  pathname: string,
  projectIdentifier: string
) => {
  const match = matchPath<RouteParams<'WORKSPACE_PROJECT'>>(pathname, {
    path: routes.WORKSPACE_PROJECT.template(),
    exact: true,
    strict: false,
  })

  return match?.params?.projectId === projectIdentifier
}

export const getProjectIdFromUrl = () => {
  const match = matchPath<RouteParams<'WORKSPACE_PROJECT'>>(
    window.location.pathname,
    {
      path: routes.WORKSPACE_PROJECT.template(),
      exact: true,
      strict: false,
    }
  )

  return match?.params?.projectId
}

export const isViewingWorkspace = (
  pathname: string,
  workspaceIdentifier: string
) => {
  const match = matchPath<RouteParams<'WORKSPACE'>>(pathname, {
    path: routes.WORKSPACE.template(),
    strict: false,
  })

  return match?.params?.workspaceId === workspaceIdentifier
}

export const isMyDrafts = (
  project: Pick<
    ProjectFragment,
    'projectType' | 'name' | 'parentProjectIdentifier'
  >
) =>
  project.projectType === 'PERSONAL_DRAFTS' &&
  project.name === 'My Drafts' &&
  project.parentProjectIdentifier === null
